import Line from './Line'
const charts = {
    Line
}

export default charts